import { createApi } from '@reduxjs/toolkit/query/react'
import { GET_DASHBOARD_DATA } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: axiosBaseQuery({
    baseUrl: '',
  }),
  endpoints: (builder) => ({
    getDashboardData: builder.query({
      query: () => ({
        method: "GET",
        url: GET_DASHBOARD_DATA
      }),
    }),
  }),
})

export const { useGetDashboardDataQuery } = dashboardApi;